import { faFileInvoiceDollar } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Typography } from '@mui/material';
import './styles.css';
import { sxButtonText } from './sxProps';
import { PedidoReembolsoCardProps } from "../../../../interfaces/props/Financeiro/Reembolso/PedidoReembolsoCardProps";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { getBenef } from "../../../../Store/storages/BeneficiarioStorage";
import { dateToText } from "../../../../utils/MonthMap";


const PedidoReembolsoCard = (props: PedidoReembolsoCardProps) => {

  const accessibility = useAccessibility();

  function removerAcentos(texto: string): string {
    return texto.replace(/\s/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  return (
    <div className='meus-reembolsos-card-holder' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
      <div className='schedule-card-icon-holder'>
        <FontAwesomeIcon style={accessibility.contrastColorAccessibility} icon={faFileInvoiceDollar} className='fadt-file-contract' />
      </div>
      <div className="meus-reembolsos-card-info">
        <span style={accessibility.textStyleAccessibility} className='meus-reembolsos-info'><b>{`Nome:`}</b> {getBenef()?.nome.toLocaleLowerCase() + " " + getBenef()?.sobrenome.toLocaleLowerCase()}</span>
        <span style={accessibility.textStyleAccessibility} className='meus-reembolsos-info'><b>Protocolo:</b> {props.reembolso.codProtocAns}</span>
        <span style={accessibility.textStyleAccessibility} className='meus-reembolsos-info'><b>Data da solicitação:</b> {props.reembolso.dtPedido}</span>
        <span className='meus-reembolsos-info' style={{ ...accessibility.textStyleAccessibility, color: props.reembolso.colorStatus }}><b style={{ color: accessibility.contrastMode ? 'white' : '#383838' }}>Status:</b> {props.reembolso.status}</span>
        <div>
          <div>
            <Button 
              onClick={() => props.handleClickVerDetalhes(props.reembolso.idPedidoReembolso, removerAcentos(props.reembolso.status),props.reembolso.acessoReanalise)} 
              aria-label={`Visualizar detalhes da solicitação ${props.reembolso.codProtocAns}, solicitado em ${dateToText(props.reembolso.dtPedido.split(" ")[0])} às ${props.reembolso.dtPedido.split(" ")[1]} que está com status ${props.reembolso.status}`}
              variant='text' 
              sx={{ ...sxButtonText }}
            >
              <Typography 
                style={{...accessibility.textStyleAccessibility, color: accessibility.contrastMode ? '#fff' : '#00995D'}} 
                sx={sxButtonText}
              >Visualizar detalhes</Typography>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PedidoReembolsoCard